export default __webpack_public_path__ + "static/media/favicon_white_v2.cd60d15d.svg";